import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "darias-design-system"
    }}>{`Daria's Design System`}</h1>
    <ul>
      <li parentName="ul">{`is a modular component library. Simple. Accessible. And gives you the building blocks to build your own React applications.`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "https://daria-s-design-system.vercel.app/"
      }}>{`Check it out here`}</a></p>
    <h2 {...{
      "id": "requirements"
    }}>{`Requirements`}</h2>
    <ul>
      <li parentName="ul">{`React`}</li>
      <li parentName="ul">{`React DOM`}</li>
      <li parentName="ul">{`Styled System`}</li>
      <li parentName="ul">{`Styled Components`}</li>
    </ul>
    <h2 {...{
      "id": "to-install-in-your-app"
    }}>{`To install in your app`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`npm i daria-s-design-system
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { mainTheme as theme } from 'daria-s-design-system'
import { ThemeProvider } from "styled-components"

export const App = ({ children }) =>
  <ThemeProvider theme={theme}>
    <>{children}</>
  </ThemeProvider>
`}</code></pre>
    <h2 {...{
      "id": "library-documentation"
    }}>{`Library documentation:`}</h2>
    <p>{`To run locally:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`yarn install
yarn docz:dev
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      